<template>
  <!-- 延时记录 -->
  <EDialog
    :centerDialogVisible.sync="dialogVisible"
    :dialog-title="dialogTitle"
    :popup-width="popupWidth"
    :show-sub-btn="false"
    @updateVisible="resetPopupData"
    @resetPopupData="resetPopupData"
    @submitPopupData="resetPopupData"
  >
    <table-list
      index-show
      :table-label="tableLabel"
      :table-data="tableData"
    ></table-list>
  </EDialog>
</template>

<script>
import EDialog from '@/modules/projectA/components/common/e-dialog';
import TableList from '@/modules/projectA/components/common/e-table-list';

export default {
  components: {
    EDialog,
    TableList
  },
  props: {
    dialogTitle: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    tableLabel: {
      type: Array,
      default() {
        return [];
      }
    },
    getList: {
      type: Function,
      default: () => {}
    },
    popupWidth: {
      type: String,
      default: '780px'
    },
    tableData: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {};
  },
  methods: {
    resetPopupData() {
      console.log('取消');
      this.$emit('update:dialogVisible', false);
    }
  }
};
</script>
<style lang="scss" scoped></style>
